import {Routes} from '@angular/router';

export const content: Routes = [
  {
    path: 'home',
    loadChildren: () => import('../../layouts/components/home/home.module').then(m => m.HomeModule),
  },
  {
    path: 'general/admit-card',
    loadChildren: () => import('../../layouts/components/admit-card/admit-card.module').then(m => m.AdmitCardModule)
  },
  {
    path: 'scheduled-exams',
    loadChildren: () => import('../../layouts/components/scheduled-exams/scheduled-exams.module').then(m => m.ScheduledExamsModule)
  },
  {
    path: 'result',
    loadChildren: () => import('../../layouts/components/result/result.module').then(m => m.ResultModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('../../layouts/components/notification/notification.module').then(m => m.NotificationModule)
  },
  {
    path: 'support-ticket',
    loadChildren: () => import('../../layouts/components/support-ticket/support-ticket.module').then(m => m.SupportTicketModule)
  },
  {
    path: 'help',
    loadChildren: () => import('../../layouts/components/help-support/help-support.module').then(m => m.HelpSupportModule)
  },
];

export const landing: Routes = [
  {
    path: 'landing',
    loadChildren: () => import('../../landing/pages-list/Landing/Landing.module').then(m => m.LandingModule)
  }
];
